module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lv3y6N/tc-custom/9781459211094.jpg?1705026307207",
      "alt": "This image is the cover for the book Cattle King's Mistress, Kings of the Outback"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cattle King's Mistress, Kings of the Outback\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Nathan King, powerful head of his legendary family's cattle empire, has everything-except a woman to share his life. Miranda Wade has nothing -- except a past she is determined to leave behind, and the hope that her new job at King's Eden will give her a fresh start."), _c('br'), _c('br'), _vm._v("Their two lives collide! Nathan wants her, but doubts she will cope with outback life. Miranda wants him, but believes her past will deny her any chance at a future with a King. The tension -- the need -- between them is overwhelming, regardless of where it might lead.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Emma Darcy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0